exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".big-and-bold0{fill:#FFFFFF;}\n.big-and-bold1{fill:#00993f;}\n.big-and-bold2{opacity:0.5;}\n.big-and-bold3{fill:#F5F5F5;}\n.big-and-bold4{fill:#EE7470;}\n.big-and-bold5{fill:#72CAC2;}\n.big-and-bold6{fill:#E5E5E5;}", ""]);
